import script from "./NewDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./NewDrawer.vue?vue&type=script&setup=true&lang=js"

import "./NewDrawer.vue?vue&type=style&index=0&id=32119fbe&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32119fbe"]])

export default __exports__